import { useNavigate } from "react-router";
import { link } from "types/CMS/Unum/link";

type navigateProps = Partial<Omit<link, "label"> & {
  beforeNavigate?: () => void;
  onError?: (error: string) => void;
}>;

const useInternalExternalNavigate = () => {
  const navigate = useNavigate();
  return ({ url, type, beforeNavigate, onError }: navigateProps) => {
    if (!url) return onError?.("Link URL is missing");
    if (!type || type === "unknown")
      return onError?.("Link type is missing or unknown");

    beforeNavigate?.();

    if (type === "internal") {
      navigate(url);
    } else if (type === "external") {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      onError?.("Unknown link type");
    }
  };
};

export default useInternalExternalNavigate;
